import React from 'react';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './StoreEntryStep4.module.scss';
import { useTranslation } from 'react-i18next';
export interface StoreEntryStep4Props {
  onComplete?: () => void;
}




// 店铺入驻第五步：Finish & Enter Seller Dashboard
const StoreEntryStep4: React.FC<StoreEntryStep4Props> = ({
  onComplete
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  // 处理完成
  const handleComplete = () => {
    navigate('/yourtownloop/yourStore');
  };

  // 处理跳转到Seller Dashboard
  const handleSellerDashboard = () => {
    navigate('/yourtownloop/yourStore');
  };

  return (
    <div className={styles['store-entry-step4']}>
      <div className={styles['header']}>
        <div className={styles['header-title']}>{t('StoreEntryStep4.FinishDashboard')}</div>
        <div className={styles['header-protection']}>
          <span className={styles['protection-icon']}>✓</span>
          {t('StoreEntryStep4.YourOut')}
        </div>
      </div>

      <div className={styles['success-container']}>
        <div className={styles['success-icon']}>
          <CheckOutlined className={styles['check-icon']} />
        </div>
        <div className={styles['success-title']}>
          {t('StoreEntryStep4.Storefully')}
        </div>
        <div className={styles['dashboard-link']} onClick={handleSellerDashboard}>
          {t('StoreEntryStep4.SellerDashboard')}
        </div>
      </div>

      
    </div>
  );
};

export default StoreEntryStep4; 